export const GRID_SIZE = 50;
/** Snap step; half the visible grid so nodes can sit on a dot or halfway between. */
export const SNAP_SIZE = GRID_SIZE / 2;

export const COLORS = {
  nodeFill: 'white',
  nodeStroke: 'black',
  imageBorder: 'white',
  label: 'black',
  edge: 'black',
  highlight: 'blue',
  hover: 'blue',
  grid: '#ccc',
};

/** World-unit stroke for node borders and links, so they stay matched under zoom. */
export const STROKE_WIDTH = 2;
export const EDGE_WIDTH = { normal: STROKE_WIDTH, hover: STROKE_WIDTH, selected: STROKE_WIDTH };
export const DASH_PATTERN = '5 5';

export const LABEL_FONT = { size: 18, family: 'arial, sans-serif' };
export const IMAGE_LABEL = { gap: 22, halo: 5 };
/** Shift from the alphabetic baseline to the visual centre. Portable; `dominant-baseline` is not. */
export const TEXT_MIDDLE = 0.35;
/** Shift from a hanging top to the alphabetic baseline. */
export const TEXT_HANGING = 0.8;

export const ZOOM = {
  min: 0.1,
  max: 8,
  wheelSpeed: 0.0012, // slower than most libraries, suits trackpads
  fitPadding: 40,
  fitMaxScale: 1.5,
};

export const CLICK_TOLERANCE = 4; // screen px a pointer may travel and still count as a click

export const PHYSICS_DEFAULTS = {
  charge: -400, // many-body strength; more negative pushes nodes apart harder
  linkStrength: 0.3,
  linkDistance: 220,
};
export const POSITION_SAVE_DELAY_MS = 5000;

export const BROKEN_IMAGE = 'no-image.svg';
